import React from "react";
import { AlertTriangle, ArrowRight } from "lucide-react";
import { CHALLENGES } from "@/lib/content";

export default function Problem() {
  return (
    <section
      id="herausforderung"
      data-testid="problem-section"
      className="relative bg-slate-50 py-24 md:py-32"
    >
      <div className="absolute inset-0 bg-grid opacity-60 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl">
          <p className="tag-line text-xs font-mono-tech uppercase tracking-[0.25em] text-slate-500 mb-6">
            Herausforderung
          </p>
          <h2
            data-testid="problem-headline"
            className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold text-slate-900 tracking-tight"
          >
            Sicherheitsinfrastruktur ist mehr als die Summe ihrer Komponenten.
          </h2>
          <p className="mt-6 text-slate-600 text-base sm:text-lg leading-relaxed">
            In der Praxis treffen Videoüberwachung, Einbruchmeldetechnik,
            Kameramasten und Netzwerkinfrastruktur oft aus unterschiedlichen
            Gewerken und von verschiedenen Anbietern aufeinander. Die Folge:
            unnötiger Abstimmungsaufwand, technische Schnittstellenprobleme
            und erhöhte Risiken im laufenden Betrieb.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-slate-200 border border-slate-200 rounded-lg overflow-hidden">
          {CHALLENGES.map((c, i) => (
            <div
              key={c.title}
              data-testid={`challenge-card-${i}`}
              className="bg-white p-8 hover:bg-slate-50 transition-colors group"
            >
              <div className="flex items-center gap-3 mb-4">
                <span className="inline-flex h-8 w-8 items-center justify-center rounded-md bg-[#FFF4E6] text-[#B45309]">
                  <AlertTriangle className="h-4 w-4" />
                </span>
                <span className="font-mono-tech text-xs text-slate-400">
                  0{i + 1}
                </span>
              </div>
              <h3 className="font-display font-medium text-lg text-slate-900">
                {c.title}
              </h3>
              <p className="mt-3 text-slate-600 text-sm leading-relaxed">
                {c.text}
              </p>
            </div>
          ))}
        </div>

        <div
          data-testid="problem-bridge"
          className="mt-16 flex flex-col md:flex-row md:items-center gap-6 md:gap-10 border-t border-slate-200 pt-10"
        >
          <div className="flex-1">
            <p className="font-display text-2xl sm:text-3xl text-slate-900 font-semibold leading-snug">
              Xortec löst diese Herausforderungen mit einer vollständig
              integrierten Systemlösung.
            </p>
          </div>
          <a
            href="#loesung"
            className="inline-flex items-center gap-2 text-[#0055A4] font-medium hover:gap-3 transition-all"
          >
            Zur Gesamtlösung
            <ArrowRight className="h-4 w-4" />
          </a>
        </div>
      </div>
    </section>
  );
}
